import { usaStates, canadianProvincesAndTerritories } from "utils/constants";

export const formattedUSStates = [
  { value: "ALL_USA", label: "All USA" },
  { value: "ALL_CANADA", label: "All Canada" },
  ...usaStates.map((state) => ({
    value: state.value,
    label: `${state.value} - ${state.label}`,
  })),
];

export const formattedCanadianProvinces = [
  ...canadianProvincesAndTerritories.map((province) => ({
    value: province.value,
    label: `${province.value} - ${province.label}`,
  })),
];

export const prepareForFetch = (selectedOptions) => {
  const isAllUSASelected = selectedOptions.some((item) => item.value === "ALL_USA");
  const isAllCanadaSelected = selectedOptions.some((item) => item.value === "ALL_CANADA");

  let newDestinations = [...selectedOptions];
  if (isAllUSASelected) {
    const allUSStates = usaStates.map((state) => ({
      value: state.value,
      label: `${state.value} - ${state.label}`,
    }));
    newDestinations = newDestinations
      .filter((item) => item.value !== "ALL_USA")
      .concat(allUSStates);
  }

  if (isAllCanadaSelected) {
    const allCanadianProvinces = canadianProvincesAndTerritories.map((province) => ({
      value: province.value,
      label: `${province.value} - ${province.label}`,
    }));
    newDestinations = newDestinations
      .filter((item) => item.value !== "ALL_CANADA")
      .concat(allCanadianProvinces);
  }

  return newDestinations.length ? newDestinations : null;
};

// export const destinationRenderer = (selected, text) => {
//   const selectedValues = selected.map(item => item.value);
//   const isAllUSASelected = selectedValues.includes("ALL_USA");
//   const isAllCanadaSelected = selectedValues.includes("ALL_CANADA");

//   const individualCount = selected.filter(item => item.value !== "ALL_USA" && item.value !== "ALL_CANADA").length;

//   let displayText = text;

//   if (isAllUSASelected && isAllCanadaSelected) {
//     displayText += ": All USA, All Canada";
//   } else if (isAllUSASelected && !isAllCanadaSelected) {
//     displayText += ": All USA";
//   } else if (isAllCanadaSelected && !isAllUSASelected) {
//     displayText += ": All Canada";
//   } else if (individualCount > 0 && individualCount <= 7) {
//     displayText += `: ${selected.map(item => ` ${item.value}`).join(", ")}`;
//   } else if (individualCount > 7) {
//     displayText += `: ${individualCount} selected`;
//   }

//   return displayText;
// };
export const destinationRenderer = (selected, text) => {
  const selectedValues = selected.map((item) => item.value);
  const isAllUSASelected = selectedValues.includes("ALL_USA");
  const isAllCanadaSelected = selectedValues.includes("ALL_CANADA");

  const individualCount = selected.filter(
    (item) => item.value !== "ALL_USA" && item.value !== "ALL_CANADA",
  ).length;

  return (
    <div>
      {text}
      {isAllUSASelected && <span> All USA</span>}
      {isAllCanadaSelected && (
        <span>{isAllUSASelected ? ", All Canada" : " All Canada"}</span>
      )}
      {individualCount > 0 && individualCount <= 6 && (
        <span> {selected.map((item) => item.value).join(", ")}</span>
      )}
      {individualCount > 6 && <span> {individualCount} selected</span>}
    </div>
  );
};
